<template>
  <div
    v-tooltip.left="{
    content: locationDenied? 'Location denied! Click to ask again':'Ask for location',
    classes: locationDenied? ['brand']: [],
     }"
    class="control gps-control"
    @click="askForGps"
  >
    <img src="../../assets/icon_location.svg" style="height: 28px;">
    <div class="lds-ring" v-if="isLoading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="location-denied" v-if="locationDenied">
      <fa-icon icon="exclamation-triangle"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GpsControl',
    props: {
      localDataTrack: {
        type: Object
      },
      remoteDataTrack: {
        type: Object
      }
    },

    data: () => ({
      waitingForGpsTimeout: null,
      isLoading: false,
      locationDenied: false,
    }),

    methods: {
      askForGps() {
        this.localDataTrack && this.localDataTrack.send('L');

        this.locationDenied = false;
        this.isLoading = true;
        clearTimeout(this.waitingForGpsTimeout);
        this.waitingForGpsTimeout = setTimeout(() => {
          this.isLoading = false;
          this.locationDenied = true
        }, 30000)
      },

      subscribeToRemoteTrack() {
        if (this.remoteDataTrack) {
          this.remoteDataTrack.on('message', (data) => {
            if (/^L,D$/.test(data)) {
              clearTimeout(this.waitingForGpsTimeout);
              this.isLoading = false;
              this.locationDenied = true;
            } else if (/^L,(-\d+|\d+)\.\d+,(-\d+|\d+)\.\d+/.test(data)) {
              let coordinates = data.split(',').splice(1, 2);
              clearTimeout(this.waitingForGpsTimeout);
              this.isLoading = false;
              this.$emit('coordinatesReceived', coordinates);
            }
          })

        }
      }
    },

    watch: {
      remoteDataTrack() {
        this.subscribeToRemoteTrack()
      }
    }
  }
</script>

<style lang="scss">
  @import "GpsControl";
</style>
